export default __webpack_public_path__ + "static/backgroundChampions-679514946737bb7eb1710ce19e60dba8.jpg";